import { EventContentArg } from '@fullcalendar/core';
import { renderEventBar } from '../components/eventBarRenderer';
import { getCalendarConfigByName } from '../../../constants/subscribedCalendars';

/**
 * 구독 캘린더 이벤트 포맷터
 * - SRP: 구독 이벤트의 콘텐츠 생성만 담당
 * - 시간 표시 없이 제목만 표시
 * - prefix 설정이 있으면 제목 앞에 추가
 */
export const renderSubscribedEvent = (eventInfo: EventContentArg) => {
  const backgroundColor = eventInfo.event.backgroundColor || '#1a73e8';
  const borderColor = eventInfo.event.borderColor || backgroundColor;
  const textColor = eventInfo.event.textColor || '#ffffff';

  // prefix 가져오기
  const calendarName = eventInfo.event.extendedProps?.calendarName;
  const calendar = getCalendarConfigByName(calendarName);
  const prefix = calendar?.prefix || '';

  const content = prefix + eventInfo.event.title;

  return renderEventBar(content, backgroundColor, borderColor, textColor);
};
